import { render, staticRenderFns } from "./invoicedetail.vue?vue&type=template&id=34c3c4df&scoped=true&"
import script from "./invoicedetail.vue?vue&type=script&lang=js&"
export * from "./invoicedetail.vue?vue&type=script&lang=js&"
import style0 from "./invoicedetail.vue?vue&type=style&index=0&id=34c3c4df&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c3c4df",
  null
  
)

export default component.exports